import { MarkType } from '@const/consts'
import { IPrepositionMarks } from '@store/modules/shared/types'

const markTypesLinkedByType = [MarkType.INITIALS, MarkType.FULLNAME, MarkType.POSITION]

export const isFilledMarkValue = (value: IPrepositionMarks[string]['value']): boolean => {
  if (typeof value === 'boolean') return value

  return !!value?.toString().length
}

export const getLinkedMarkKeys = (marks: IPrepositionMarks, currentKey: string): string[] => {
  const currentMark = marks[currentKey]

  if (!currentMark) return []

  if (markTypesLinkedByType.includes(currentMark.type)) {
    return Object.keys(marks).filter(key => marks[key].type === currentMark.type)
  }

  if (currentMark.type === MarkType.CUSTOM && currentMark.label) {
    return Object.keys(marks).filter(key =>
      marks[key].type === MarkType.CUSTOM && marks[key].label === currentMark.label,
    )
  }

  return [currentKey]
}

export const normalizeCustomMarkValues = (marks: IPrepositionMarks): IPrepositionMarks => {
  const normalizedMarks = Object.keys(marks).reduce<IPrepositionMarks>((acc, key) => {
    acc[key] = { ...marks[key] }

    return acc
  }, {})
  const handledLabels = new Set<string>()

  Object.keys(normalizedMarks).forEach(key => {
    const currentMark = normalizedMarks[key]

    if (currentMark.type !== MarkType.CUSTOM || !currentMark.label || handledLabels.has(currentMark.label)) return

    const linkedKeys = getLinkedMarkKeys(normalizedMarks, key)
    const firstFilledValue = linkedKeys
      .map(linkedKey => normalizedMarks[linkedKey].value)
      .find(isFilledMarkValue)

    if (typeof firstFilledValue !== 'undefined') {
      linkedKeys.forEach(linkedKey => {
        normalizedMarks[linkedKey] = {
          ...normalizedMarks[linkedKey],
          value: firstFilledValue,
        }
      })
    }

    handledLabels.add(currentMark.label)
  })

  return normalizedMarks
}
